import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken, setUser, getToken } from "../server";

function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Redirect if already logged in
  useEffect(() => {
    if (getToken()) navigate("/dashboard", { replace: true });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!identifier || !password) {
      setError("Phone/Email and password are required");
      return;
    }
    setLoading(true);
    try {
      // Backend accepts a single "identifier" and auto-detects email vs phone
      const data = await api.post("/api/admin/auth/login", {
        identifier: identifier.trim(),
        password,
      });
      setToken(data.token);
      setUser(data.admin);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="blue-light-bg">
      <section className="container d-flex flex-column vh-100">
        <div className="row align-items-center justify-content-center g-0 h-lg-100 py-8">
          <div className="col-lg-5 col-md-8 py-8 py-xl-0">
            <div className="card shadow rounded-4">
              <div className="card-body p-6 d-flex flex-column rounded-5 gap-3">
                <div className="d-flex align-content-center align-items-center mb-1">
                  <div>
                    <h1 className="m-0 fw-bold h2 lh-1">Sign in</h1>
                    <p className="fs-4 mb-0 lh-sm">
                      Water Delivery — Admin Panel
                    </p>
                  </div>
                </div>

                {error && (
                  <div className="alert alert-danger py-2 mb-0">{error}</div>
                )}

                <form className="needs-validation" onSubmit={handleLogin}>
                  <div className="mb-3">
                    <label className="form-label mb-1 ms-3">
                      Phone No. / Email ID
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone No. / Email ID"
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label mb-1 ms-3">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="**********"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="d-grid mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary rounded-pill"
                      disabled={loading}
                    >
                      {loading && (
                        <span className="spinner-border spinner-border-sm me-2" />
                      )}
                      {loading ? "Signing in..." : "Sign in"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Login;
